import { render, staticRenderFns } from "./NbPageFooterLink.vue?vue&type=template&id=44c1434e&scoped=true&"
import script from "./NbPageFooterLink.vue?vue&type=script&lang=js&"
export * from "./NbPageFooterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c1434e",
  null
  
)

export default component.exports